import { render, staticRenderFns } from "./plans-mobile.vue?vue&type=template&id=c68bb63a&scoped=true&"
import script from "./plans-mobile.vue?vue&type=script&lang=js&"
export * from "./plans-mobile.vue?vue&type=script&lang=js&"
import style0 from "./plans-mobile.vue?vue&type=style&index=0&id=c68bb63a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68bb63a",
  null
  
)

export default component.exports